import {
  useGetUserNotificationPagedFilterDIPQuery,
  useMarkAllListedAsSeenDIPMutation,
} from "Application/Notification/services/api";
import BottomSheet from "Components/BottomSheet";
import Icon from "Components/Icon";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { IApplicationState } from "Store/types";

interface BottomSheetProps {
  open: boolean;
  onClose: () => void;
}

function BottomSheetReadAll({ open, onClose }: BottomSheetProps) {
  const ssoId = useSelector(
    (root: IApplicationState) => root.notification.ssoId
  );

  const { data, refetch } = useGetUserNotificationPagedFilterDIPQuery();
  const [MarkAllSeen] = useMarkAllListedAsSeenDIPMutation();

  const receivers =
    data?.queryResult?.flatMap((item: any) => item.notificationReceiverQr) ||
    [];

  const seenCount = receivers.filter(
    (r: any) => r.receiverStatus === "Seen"
  ).length;

  const totalCount = receivers.length;

  const handleReadAllClick = async () => {
    try {
      if (!ssoId) throw new Error("ssoId is missing!");

      if (totalCount > 0 && seenCount === totalCount) {
        toast("همه پیام‌ها قبلاً خوانده شده‌اند 🚫");
        return;
      }

      await MarkAllSeen({ ssoId }).unwrap();

      await refetch();
    } catch (error: any) {
      console.error(error?.data?.[0]);
    }
  };

  return (
    <BottomSheet visible={open} title="" onCancel={onClose}>
      <div
        className="flex items-center justify-center m-8 p-4 gap-2"
        style={{ paddingBottom: "2rem" }}
      >
        <Icon name="read_all" id="read_all" className="mr-2" />
        <span
          className=" font-bold"
          style={{ color: "#1E5FAA" }}
          onClick={handleReadAllClick}
        >
          تغییر همه پیام‌ها به حالت خوانده
        </span>
      </div>
    </BottomSheet>
  );
}

export default BottomSheetReadAll;
